/**
 * Payroll engine version. Bump on EVERY behavior change; stamp on every
 * preview, backtest, run record, and report header (two "stale version"
 * incidents motivated this — see docs/Payroll/PLAN.md §5).
 *
 * CHANGELOG
 *   v3.2.0-hub — 2026-11-03 (D-51, leadership ruling via Mitchell — prompted
 *     by Johnny Barfield / Valentina Ramos Gomez row 1000): 90-day new-hire
 *     TCPI grace. Self-sourced single-submission fee capped at $200 for
 *     closings within [profile start_date, start_date + 90 days] (start = day
 *     0, day 90 inclusive) unless the contract fee is already lower. Explicit
 *     fee overrides and $0 waivers win; CD fees and sub2/sub3 adders
 *     unchanged. Flag TCPI_90D_GRACE. No-op while start_date is NULL.
 *     Backfilled start dates (GA account creation): Tyler Spurlock
 *     2026-01-13 (no Hub-paid rows in window), Johnny Barfield 2026-08-03 —
 *     his row 1000 (Valentina, closed 10/30 = day 88) was paid pre-D-51 at
 *     the contract $350 + $150 sub2; a re-run now computes $200 + $150, so
 *     a +$150 true-up is pending leadership sign-off (see 11/03 report).
 *   v3.1.0-hub — 2026-09-02 (D-50, Marilyn ruling via Mitchell — Rylee Allen
 *     row 852): LP vs BP is decided by the revenue ultimately earned vs the
 *     expected margin ONLY; comp-code tags never decide pricing. No-margin
 *     rows default LP; a BP tag there is flag-only (BP_TAG_IGNORED_NO_MARGIN,
 *     was "No margin data, Comp Code marked BP" → BP in v2.9/v3.0.0).
 *     Delta report: docs/Payroll/deltas/v3.1.0-D50.json.
 *   v3.0.0-hub — parity port of PayrollAutomation_v2.gs
 *     "v2.9 — 2026-08-11 (skip splits lacking a Secondary LO)".
 *     Known preserved defects (fix versions pending sign-off):
 *     D-21 CD Flat Tier2, D-22 tier-count scope, D-23 Max-Comp fee,
 *     D-24 Ronda LOA scope, D-25 Branch margin column (W2 proxy in force),
 *     D-26 lender aliases (table empty), D-27 "Self Soruced" regex miss.
 */

const ENGINE_VERSION = 'v3.2.0-hub — 2026-11-03 (D-51: 90-day new-hire TCPI grace — SS fee capped at $200 through day 90 from profile start_date)';

const PARITY_BASE = 'v2.9 — 2026-08-11 (skip splits lacking a Secondary LO)';

module.exports = { ENGINE_VERSION, PARITY_BASE };
